import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDocumentTitle } from '../../shared/use-document-title';
import { useRouting } from '../../shared/use-routing';
import { ImageCardsSection } from '../../components/Landing/ImageCardsSection';
import { PageHeroSection } from '../../components/Landing/PageHeroSection';
import { IconCard } from '../../components/Landing/IconCard';
import { FaqSection } from '../../components/Landing/FaqSection';
import { pagePathnames } from '../page-routes';
import { uiConfig } from '../../app-ui-config';
import { SUPPORT_EMAIL, SUPPORT_PHONE, SUPPORT_PHONE_DISPLAY } from '../../shared/links';
import helpSrc from '../../assets/images/contact-us/help.webp';

function ContactUsPage() {
    const { location, lang, buildPath, stripLangPrefix } = useRouting();
    const navigate = useNavigate();
    const { t } = useTranslation();

    useDocumentTitle(t('contactUsPage.documentTitle'), false);

    const currentPath = stripLangPrefix(location.pathname);
    const canonicalPath = lang === 'de' ? pagePathnames.impressum : pagePathnames.contactUs;

    useEffect(() => {
        if (currentPath !== canonicalPath) {
            navigate(buildPath(canonicalPath), { replace: true });
        }
    }, [currentPath, canonicalPath, buildPath, navigate]);

    return (
        <>
            <PageHeroSection
                title='Contact us'
                subtitle='Have a question about your account, a chapter, or your subscription? Reach out anytime — our team typically replies within a day.'
            />
            <ImageCardsSection
                title='We’re here to help'
                imageSrc={helpSrc}
            >
                <IconCard
                    iconName='mail'
                    title='Email us'
                    description='The fastest way to reach us for account or billing questions.'
                    actionLabel={SUPPORT_EMAIL}
                    actionHref={`mailto:${SUPPORT_EMAIL}`}
                />
                <IconCard
                    iconName='phone'
                    title='Call Us'
                    description='Speak with our support team directly, anytime.'
                    actionLabel={SUPPORT_PHONE_DISPLAY}
                    actionHref={`tel:${SUPPORT_PHONE}`}
                />
                <IconCard
                    iconName='help'
                    title='Visit help center'
                    description='Browse how-to guides and answers to common questions.'
                    actionLabel='Open Help Center →'
                    actionHref={uiConfig.helpCenterLink}
                />
            </ImageCardsSection>
            <FaqSection />
        </>
    );
}

export {
    ContactUsPage
};
